import { render, staticRenderFns } from "./InformationRequestDetail.vue?vue&type=template&id=ff5f29a0"
import script from "./InformationRequestDetail.vue?vue&type=script&lang=js"
export * from "./InformationRequestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports